import React from 'react';
import { Box } from '@mui/material';
import PublicHeader from './PublicHeader';

const PublicLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
    <PublicHeader />
    <Box component="main">{children}</Box>
  </Box>
);

export default PublicLayout;
